import React from 'react';
export function Footer() {
  return <>
      {/* Final CTA Section */}
      <section className="w-full bg-primary py-20 px-4 text-center" data-id="element-85">
        <div className="max-w-3xl mx-auto" data-id="element-86">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-white mb-8" data-id="element-87">
            ¿Listo/a para recuperar tu tiempo?
          </h2>
          <a href="https://pack-e-f-lista.impultienda.ar/checkout" className="inline-block bg-white text-primary font-bold text-lg sm:text-xl px-10 py-4 rounded-full hover:bg-bg-main transition-colors shadow-lg" data-id="element-88">
            QUIERO EL PACK EF LISTA
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full bg-[#1A1A1A] py-12 px-4" data-id="element-89">
        <div className="max-w-4xl mx-auto text-center" data-id="element-90">
          <div className="text-white text-2xl font-serif font-black tracking-widest mb-6 flex items-center justify-center gap-2" data-id="element-91">
            <span data-id="element-92">⚽</span> EDUCACIÓN FÍSICA LISTA
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 text-sm text-white/70 mb-8" data-id="element-93">
            <a href="#" className="hover:text-white transition-colors" data-id="element-94">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-95">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-96">
              Contacto
            </a>
          </div>

          <p className="text-white/40 text-xs" data-id="element-97">
            © {new Date().getFullYear()} EDUCACIÓN FÍSICA LISTA — Todos los
            derechos reservados.
          </p>
        </div>
      </footer>
    </>;
}